// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M19,12l-2.9,2.9l-0.7-0.8l2.1-2.1l-2.1-2.1l0.7-0.8L19,12z M7.9,9.1L5,12l2.9,2.9l0.7-0.8L6.5,12l2.1-2.1L7.9,9.1z M22,12
		c0,5.5-4.5,10-10,10S2,17.5,2,12S6.5,2,12,2S22,6.5,22,12z M21,12c0-5-4-9-9-9s-9,4-9,9s4,9,9,9S21,17,21,12z M9.6,16.5l1,0.3
		l3.7-9.3l-0.9-0.3L9.6,16.5z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-code-circle-Bo0lZs8T.js.map
